<script lang="ts">
    import page from "page";

    import Chat from "./Chat.svelte";
    import LiveSetting from "./LiveSetting.svelte";

    let current = Chat;

    page("/", () => (current = Chat));
    page(
        "/prescribe.lifestylemedicine.io/live-setting",
        () => (current = LiveSetting)
    );

    page.start();
</script>

<svelte:component this={current} />
